import script from "./carousel.vue?vue&type=script&setup=true&lang=js"
export * from "./carousel.vue?vue&type=script&setup=true&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=c6404d6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6404d6e"]])

export default __exports__